import React, { useEffect, useState } from "react";
import { ArchiveContainer, Container, Nodata } from "./index.styled";
import RootLayout from "components/layout/rootLayout";
import TableSection from "components/tables/TableSection";
import { useSocket } from "hooks/socket";
import { toast } from "react-toastify";
import useWindowDimensions from "hooks/useWindowDimensions";
import TableSectionMobile from "components/tables/tableSectionMobile";
import { Helmet } from "react-helmet";
import { logger } from "utils/logger/logger";
import { debounce } from "utils/debounce";

const Archive = () => {
  const [socketStatus, setSocketStatus] = useState("processing");
  //  const [socketStatus, setSocketStatus] = useState("processing");
  //this socket status  state updates row if they change from processing to done
  // until now after updating the page refetches new Item in Table & desktopTable
  // because the socket result use to send the status
  // but now from backend socket will respond with aiResult like below |:
  // {  aiResult  :   "ae755c34174311ef99eb0242ac110005.mp3"
  //   archiveId  :   "f2e2ce98-3096-4b6f-8d04-f978e97ce195"
  //     messages  :   "پردازش با موفقیت انجام شد"
  //   status  :   "success"
  // }
  // so it doesn't need to refetch on tables
  // because now we have the aiResult
  // but we need to change some components to change type of state from string into object and so on ...
  // currently I cant do that because components are so fragile and error prune

  // data fetching should move From tables into this <Archive/> file  and pass as props to tables and after retriving data from socket the state should be
  //updated locally
  // good luck doing that ...

  const socketJs = useSocket();

  useEffect(() => {
    if (!socketJs) {
      return;
    }

    socketJs.on("connect", (data) => {
      logger.log()("socket connected ", data);
    });

    socketJs.on("archiveResult", (data) => {
      logger.log()("archiveResult data here : ", data);
      if (data.status) {
        logger.log()("Data in socket in Archive ", data);
        setSocketStatus(data.status);
      }
      if (data.status==='success'){
        if(data.messages){
          toast.success(data.messages);
        }
      }
      if(data.status==='failure'){
        toast.warning(data.messages);
      }
    });

    socketJs.on("connect_error", (err) => {
      logger.log()(err.message);
    });

    return () => {
      logger.log()("socket closed in archive unmount");
      socketJs.close();
    };
  }, [socketJs]);

  const dim = useWindowDimensions();

  return (
    <>
      <Helmet>
        <title>آرشیو</title>
      </Helmet>

      <RootLayout>
        <ArchiveContainer>
          <Container color="#27548C">
            <h2>آرشیو فایل ها</h2>

            {dim.width > 1024 ? (
              <TableSection socketStatus={socketStatus} />
            ) : (
              <TableSectionMobile socketStatus={socketStatus} />
            )}
          </Container>
        </ArchiveContainer>
      </RootLayout>
    </>
  );
};

export default Archive;
